import api from "@/utils/axios";

const SETTINGS_API_URL = `/settings`;

export default {
  namespaced: true,
  state: {
    settings: [],
    setting: null,
    loading: false,
    error: null,
  },
  mutations: {
    SET_SETTINGS(state, settings) {
      state.settings = settings;
    },
    SET_SETTING(state, setting) {
      state.setting = setting;
    },
    UPDATE_SETTING(state, updatedSetting) {
      const index = state.settings.findIndex(
        (s) => s.key === updatedSetting.key
      );
      if (index !== -1) {
        state.settings.splice(index, 1, updatedSetting);
      }
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_SETTING(state) {
      state.setting = null;
      state.settings = [];
      state.error = null;
    },
  },
  actions: {
    async fetchSettings({ commit }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.get(`${SETTINGS_API_URL}/all/`, {
          successNotify: false,
        });
        commit("SET_SETTINGS", response.data.settings);
      } catch (error) {
        commit("SET_ERROR", error.response?.data || error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchSetting({ commit }, key) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.get(`${SETTINGS_API_URL}/${key}/`, {
          successNotify: false,
        });
        commit("SET_SETTING", response.data.setting);
      } catch (error) {
        commit("SET_ERROR", error.response?.data || error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateSetting({ commit }, { key, value }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.put(`${SETTINGS_API_URL}/${key}/`, {
          value,
        });
        commit("SET_SETTING", response.data.setting);
        commit("UPDATE_SETTING", response.data.setting);
      } catch (error) {
        commit("SET_ERROR", error.response?.data || error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    settings: (state) => state.settings,
    setting: (state) => state.setting,
    settingLoading: (state) => state.loading,
    settingError: (state) => state.error,
  },
};
